// ----------------------------------------------------------------------------
// Component: Content Panel -- Video
// ----------------------------------------------------------------------------

// -------------------------------------
// Variables
// -------------------------------------

// Selectors
const VIDEO_CONTAINER_SELECTOR = '.content-panel__meta';
const PLAY_BUTTON_SELECTOR     = '.content-panel__meta .video-control';
const VIDEO_SELECTOR           = 'video';

// Classes
const PLAYING_CLASS = 'js--is-playing';


// -------------------------------------
// Helpers
// -------------------------------------

function handleClick(event) {
    playVideo(event.currentTarget, 'click');
}

function handleKeyboard(event) {
    const key = event.key;

    if (key === ' ' || key === 'Enter') {
        playVideo(event.currentTarget, 'keyboard');
    }
}

function playVideo(button, source) {
    const parentContainer = button.closest(VIDEO_CONTAINER_SELECTOR);
    const video = parentContainer.querySelector(VIDEO_SELECTOR);

    parentContainer.classList.add(PLAYING_CLASS);
    video.setAttribute('controls', 'controls');
    video.play();

    if (source === 'keyboard') {
        video.focus();
    }
}


// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', function() {
    const playButtons = document.querySelectorAll(PLAY_BUTTON_SELECTOR);

    playButtons.forEach(function(button) {
        button.addEventListener('click', handleClick);
        button.addEventListener('keydown', handleKeyboard);
    });
});